import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=2982b1c4&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BranchDetail.vue?vue&type=style&index=1&id=2982b1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982b1c4",
  null
  
)

export default component.exports